/** Feature flags for launch vs lab/personal tools. Stored on users.features in Firestore. */

export const FEATURES = {
  TV: 'tv',
  CS2: 'cs2',
  EBAY: 'ebay',
  DAY_TRADING: 'dayTrading',
  BASKETBALL: 'basketball',
  WELLNESS: 'wellness',
  WORKOUTS: 'workouts',
  ALL: 'all',
};

export const ALL_GRANTABLE_FEATURES = [
  FEATURES.TV,
  FEATURES.CS2,
  FEATURES.EBAY,
  FEATURES.DAY_TRADING,
  FEATURES.BASKETBALL,
  FEATURES.WELLNESS,
  FEATURES.WORKOUTS,
];

/** Default for new signups — core product + kitchen TV, no lab cards. */
export const DEFAULT_USER_FEATURES = [FEATURES.TV];

export function getBetaEmails() {
  const fromEnv = (process.env.REACT_APP_BETA_EMAILS || '')
    .split(',')
    .map((email) => email.trim().toLowerCase())
    .filter(Boolean);
  const ownerEmails = ['bakez1029@gmail.com'];
  return [...new Set([...fromEnv, ...ownerEmails])];
}

export function hasFullFeatureAccess(granted, email) {
  if (hasFeature(granted, FEATURES.ALL)) return true;
  if (Array.isArray(granted) && granted.length >= ALL_GRANTABLE_FEATURES.length) return true;
  const normalizedEmail = (email || '').trim().toLowerCase();
  return normalizedEmail && getBetaEmails().includes(normalizedEmail);
}

export function resolveUserFeatures(userData, email) {
  const betaEmails = getBetaEmails();
  const normalizedEmail = (email || userData?.email || '').trim().toLowerCase();

  if (betaEmails.length > 0 && betaEmails.includes(normalizedEmail)) {
    return [...ALL_GRANTABLE_FEATURES];
  }

  const raw = userData?.features;
  if (Array.isArray(raw) && raw.length > 0) {
    if (raw.includes(FEATURES.ALL)) return [...ALL_GRANTABLE_FEATURES];
    return raw.filter((f) => f && f !== FEATURES.ALL);
  }

  return [...DEFAULT_USER_FEATURES];
}

export function hasFeature(granted, feature) {
  if (!feature) return true;
  if (!Array.isArray(granted) || granted.length === 0) return false;
  if (granted.includes(FEATURES.ALL)) return true;
  return granted.includes(feature);
}

/** TV cards that require a feature flag (core cards are always available). */
export const TV_CARD_REQUIRES_FEATURE = {
  cs2: FEATURES.CS2,
  basketball: FEATURES.BASKETBALL,
  yoga: FEATURES.WELLNESS,
  stretching: FEATURES.WELLNESS,
  meditation: FEATURES.WELLNESS,
  dayTrading: FEATURES.DAY_TRADING,
  ecommerce: FEATURES.EBAY,
  workouts: FEATURES.WORKOUTS,
};

/** Cards hidden by default even when the user has the feature. */
export const TV_ALWAYS_HIDDEN_BY_DEFAULT = ['ecommerce'];

export function isTvCardAvailable(cardId, granted) {
  const required = TV_CARD_REQUIRES_FEATURE[cardId];
  if (!required) return true;
  return hasFeature(granted, required);
}

export function getDefaultHiddenTvCards(granted) {
  if (hasFeature(granted, FEATURES.ALL) || granted.length >= ALL_GRANTABLE_FEATURES.length) {
    return Object.entries(TV_CARD_REQUIRES_FEATURE)
      .filter(([, feature]) => !hasFeature(granted, feature))
      .map(([cardId]) => cardId);
  }
  const hidden = [...TV_ALWAYS_HIDDEN_BY_DEFAULT];
  Object.entries(TV_CARD_REQUIRES_FEATURE).forEach(([cardId, feature]) => {
    if (!hasFeature(granted, feature)) hidden.push(cardId);
  });
  return [...new Set(hidden)];
}
